var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"octadesk-app-messenger-overlay",class:{
    open: _vm.overlayOpen
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }